import { z } from 'zod';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { PRODUCT_UOM_CONVERSION_CONSTRAINTS } from './constraints.js';
export const createProductUomConversionInputSchema = z.object({
    stateId: optionalUuidString('Invalid state selection.')
        .nullable()
        .transform((value) => (typeof value === 'string' && !value.trim() ? null : value))
        .optional(),
    uomId: requiredUuidString('UOM is required.', 'Invalid UOM selection.'),
    ratio: z
        .number()
        .positive(`${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be greater than 0.`)
        .min(PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.min, `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be ${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.minMessage} or greater.`)
        .max(PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.max, `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be 1 billion or less.`),
});
//# sourceMappingURL=create-input.js.map